import React from 'react';
import RootPage from './Pages/RootPage';

function App() {
  return <RootPage />;
}

export default App;
